import { UserInfo, UserResponse } from "../types/user";
import axiosInstance from "./axiosInstance";

class UserService {
  static async getProfile(): Promise<UserResponse> {
    const response =
      await axiosInstance.get<ApiResponse<UserResponse>>(`/users/profile`);
    return response.data.result;
  }
  static async getAuthInfo(): Promise<AuthInfoResponse> {
    const response =
      await axiosInstance.get<ApiResponse<AuthInfoResponse>>(
        `/users/auth-info`,
      );
    return response.data.result;
  }
  static async updateUserInfo(param: UserInfo): Promise<UserResponse> {
    try {
      const response = await axiosInstance.put<ApiResponse<UserResponse>>(
        `/users`,
        param,
      );
      return response.data.result;
    } catch (error) {
      throw error;
    }
  }
  static async updateBillingAddress(
    param: BillingAddressDTO,
  ): Promise<UserResponse> {
    try {
      const response = await axiosInstance.put<ApiResponse<UserResponse>>(
        `/users/billing-address`,
        param,
      );
      return response.data.result;
    } catch (error) {
      throw error;
    }
  }
  static async getBillingAddress(): Promise<BillingAddressDTO> {
    try {
      const response = await axiosInstance.get<ApiResponse<BillingAddressDTO>>(
        `/users/billing-address`,
      );
      return response.data.result;
    } catch (error) {
      throw error;
    }
  }
  static async updatePassword(
    password: string,
    newPassword: string,
  ): Promise<UserResponse> {
    try {
      const response = await axiosInstance.put<ApiResponse<UserResponse>>(
        `/users/password`,
        {
          password,
          newPassword,
        },
      );
      return response.data.result;
    } catch (error) {
      throw error;
    }
  }

  static async forgotPassword(email: string): Promise<void> {
    try {
      await axiosInstance.post<ApiResponse<void>>(`/users/forgot-password`, {
        email,
      });
    } catch (error) {
      throw error;
    }
  }

  static async resetPassword({
    token,
    newPassword,
    email,
  }: {
    token: string;
    newPassword: string;
    email: string;
  }): Promise<void> {
    try {
      await axiosInstance.post<ApiResponse<void>>(`/users/reset-password`, {
        token,
        newPassword,
        email,
      });
    } catch (error) {
      throw error;
    }
  }
}

export default UserService;
